<!-- home section start -->
<div class="svr_homepage_banner home-section-2 home-section-small">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="three-slider arrow-slider ratio_27" *ngIf="DataList.length > 0">
                    <div *ngFor="let data of DataList" class="offer-banner hover-effect">
                        <img [src]="data?.slider_image ? imageBaseUrl + data?.slider_image : 'https://placehold.co/1603x294'" class="img-fluid bg-img" alt="Banner Image" />
                        <!-- <img src="https://placehold.co/1603x294" class="img-fluid bg-img" alt="Banner Image" /> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Home Section End -->
